import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';

import { App } from './core/components/root/App';
import { AppInitializationLoader } from './core/components/root/AppInitializationLoader';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found. Please check your HTML file.');
}

const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <AppInitializationLoader>
      <App />
    </AppInitializationLoader>
  </StrictMode>
);
